import Text from '@deprecated-ui/common/Text';
import { CounterContainer } from './styled';

interface ImagesCounterProps {
  current: number;
  total: number;
}

function ImagesCounter({ current, total }: ImagesCounterProps) {
  if (total === 0) {
    return null;
  }
  return (
    <CounterContainer>
      <Text size="12px" height="135%" weight="400">
        {current + 1}/{total}
      </Text>
    </CounterContainer>
  );
}

export default ImagesCounter;
